import { ActionIcon, Box, CopyButton, Flex, Text, Tooltip, rem } from '@mantine/core';
import { ChatMessage } from '@src/types/chat';
import Markdown from 'react-markdown';
import classes from './chat-message-bubble.module.css';
import { IconCheck, IconCopy } from '@tabler/icons-react';

// TODO: Add sx prop to Box
// sx={(theme) => ({
//   backgroundColor: message.isUser ? theme.colors.blue[0] : theme.colors.gray[0],
//   borderRadius: theme.radius.md,
//   padding: '10px 20px',
//   maxWidth: '70%',
//   marginLeft: message.isUser ? 'auto' : '0',
//   marginRight: message.isUser ? '0' : 'auto',
//   marginBottom: '10px',
// })}

//TODO: the results from openAI are some sort of markdown, how to we keep the formatting?
interface MessageBubbleProps {
  message: ChatMessage;
}
function MessageBubble({ message }: MessageBubbleProps) {
  return (
    <Box
      bg={message.isUser ? 'var(--mantine-color-orange-0)' : 'var(--mantine-color-gray-1)'}
      mr={message.isUser ? 0 : rem(50)}
      ml={message.isUser ? rem(50) : 0}
      className={classes.bubble}
    >
      {message.isUser ? (
        <Text ta={message.isUser ? 'right' : 'left'}>{message.text}</Text>
      ) : (
        <Box>
          <Markdown>{message.text}</Markdown>
          <Flex justify="flex-end">
            <CopyButton value={message.text} timeout={2000}>
              {({ copied, copy }) => (
                <Tooltip label={copied ? 'Copied' : 'Copy'} withArrow position="right">
                  <ActionIcon color={copied ? 'teal' : 'gray'} variant="subtle" onClick={copy}>
                    {copied ? <IconCheck size={22} /> : <IconCopy size={22} />}
                  </ActionIcon>
                </Tooltip>
              )}
            </CopyButton>
          </Flex>
        </Box>
      )}
    </Box>
  );
}

export { MessageBubble };
